export var REFRESH_REDUCERS = "REFRESH_REDUCERS";
export function refreshReducersToIntial() {
    return { type: REFRESH_REDUCERS };
}
